import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  _autoSaveStarted = 0
  _autoSaveCompleted = 0

  connect() {
    document.addEventListener('autosave:ready', this._onAutoSaveReady)
    document.addEventListener('autosave:started', this._onAutoSaveStarted)
    document.addEventListener('autosave:completed', this._onAutoSaveCompleted)
  }

  _onAutoSaveReady = () => {
    this.element.setAttribute('ready', '')
  }

  _onAutoSaveStarted = () => {
    this._autoSaveStarted++
    if (this._autoSaveStarted - this._autoSaveCompleted > 0) {
      this.element.setAttribute('in-progress', '')
    }
  }

  _onAutoSaveCompleted = () => {
    this._autoSaveCompleted++
    if (this._autoSaveStarted - this._autoSaveCompleted === 0) {
      this.element.removeAttribute('in-progress')
    }
  }
}
